export function isAdminUser(user) {
  return !!user?.attributes?.profile?.privateData?.isAdmin;
}

export function isProvider(user) {
  //return user?.attributes?.permissions?.postListings === 'permission/allow';
  return user?.attributes?.profile?.publicData?.userType === 'provider';
}
